exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-button{\n    padding: 10px;\n}\n.precio{\n    line-height: 1.32em;\n    font-weight: 600;\n}\n.gtm-button span{\n    pointer-events: none;\n}\n", ""]);

// exports
